import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { CaretDownIcon } from '@phosphor-icons/react';
import styles from './YearGroupHeader.module.css';

interface YearGroupHeaderProps {
    /** `null` = gruppen for behandlinger uten dato. */
    year: number | null;
    count: number;
    open: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

const YearGroupHeader: React.FC<YearGroupHeaderProps> = ({ year, count, open, onToggle, children }) => {
    const { t } = useTranslation();
    const panelId = useId();
    const label = year === null ? t('processings.undatedGroup') : String(year);

    return (
        <div className={styles.group}>
            <div className={styles.headerRow}>
                <button
                    type="button"
                    className={styles.trigger}
                    onClick={onToggle}
                    aria-expanded={open}
                    aria-controls={panelId}
                    aria-label={open ? t('processings.collapseYear', { year: label }) : t('processings.expandYear', { year: label })}
                >
                    <span className={styles.year}>{label}</span>
                    <CaretDownIcon
                        size={20}
                        className={`${styles.icon} ${open ? styles.iconOpen : ''}`}
                        aria-hidden
                    />
                </button>
                <span className={styles.divider} aria-hidden />
                <span className={styles.count}>{t('processings.count', { count })}</span>
            </div>
            <div
                id={panelId}
                role="region"
                aria-label={label}
                className={styles.panel}
                hidden={!open}
            >
                {children}
            </div>
        </div>
    );
};

export default YearGroupHeader;
